function drawRating(canvas, resultCurrentStage) {
    var ctx = canvas.getContext("2d"),
        stageCount = 11,
        stageRating = [],
        allStagesRating = [],
        ratingMax,
        ratingMin,
        xOffset = 50,
        yOffset = 35,
        canvasWidth = canvas.width,
        canvasHeight = canvas.height,
        graphWidth = canvasWidth - xOffset,
        graphHeight = canvasHeight - yOffset * 2;

    $('.graph-label').each(function () {
        var itemStageRating = $(this).data('stage-rating'),
            itemTotalRating = $(this).data('total-rating');

        if (itemStageRating !== '') {
            stageRating.push(itemStageRating);
        }

        if (itemTotalRating !== '') {
            allStagesRating.push(itemTotalRating);
        }
    });

    ratingMax = Math.max.apply(null, stageRating.concat(allStagesRating));
    ratingMin = Math.min.apply(null, stageRating.concat(allStagesRating));

    var yAxis = [],
        yAxisMax,
        yAxisMin,
        range;
    if (stageRating.length > 0 && allStagesRating.length > 0) {
        // Y шкала значений
        yAxisMax = ratingMax > 1000 ? Math.ceil(ratingMax / 100) * 100 : Math.ceil(ratingMax / 10) * 10;
        yAxisMin = ratingMin > 1000 ? Math.floor(ratingMin / 100) * 100 : Math.floor(ratingMin / 10) * 10;

        if (yAxisMax === yAxisMin) {
            range = yAxisMax;
        }
        else {
            range = yAxisMax - yAxisMin;
        }

        for (var i = 0; i < 6; i++) {
            var y = yAxisMin + i * (range / 5);
            y = y < 0 ? 0 : y;
            yAxis.push(y)
        };
    }

    // соотношение всех значений по отношению к максимальному
    var stageRatingRatio = ratio(stageRating, range, yAxisMin);
    var allStagesRatingRatio = ratio(allStagesRating, range, yAxisMin);

    // массивы Y координат
    var yCoordsStageRating = [];
    for (var i = 0; i < stageRatingRatio.length; i++) {
        var y = +stageRatingRatio[i] + yOffset;
        yCoordsStageRating.push(y)
    }

    var yCoordsAllStagesRating = [];
    for (var i = 0; i < allStagesRatingRatio.length; i++) {
        var y = +allStagesRatingRatio[i] + yOffset;
        yCoordsAllStagesRating.push(y)
    }

    // массив Х координат со смещением на половину столбца и 60px слева для шкалы
    var xCoords = [];
    for (var i = 0; i < stageCount; i++) {
        var x = (i * (graphWidth / stageCount) + (graphWidth / (stageCount * 2))) + xOffset;
        xCoords.push(x.toFixed(2));
    }

    if (canvas.getContext) {
        drawAxis(ctx, stageCount, yAxis);

        // рисую столбцы рейтинга для текущего этапа
        drawLine(ctx, xCoords, yCoordsStageRating);

        // рисую столбцы рейтинга общего зачета
        drawLine(ctx, xCoords, yCoordsAllStagesRating);

        // соединяю значения
        drawGraph(ctx, xCoords, yCoordsStageRating, "#ff8e32", yCoordsAllStagesRating, 'stage');
        drawGraph(ctx, xCoords, yCoordsAllStagesRating, "#6ebff7", yCoordsStageRating, 'total');

        // точки в месте значения на графике
        drawDots(ctx, xCoords, yCoordsStageRating, stageRating, yCoordsAllStagesRating, "#ff8e32", 'stage');
        drawDots(ctx, xCoords, yCoordsAllStagesRating, allStagesRating, yCoordsStageRating, "#6ebff7", 'total');
    }

    // определение соотношения
    function ratio(data, maxValue, minValue) {
        var ratioArray;
        ratioArray = data.map(function (item) {
            return ratioItem = ((item - minValue) * graphHeight / maxValue).toFixed(2);
        });
        return ratioArray;
    }

    function drawAxis(ctx, stageCount, yAxis) {
        // вертикальные оси
        for (var i = 0; i <= stageCount; i++) {
            var x = i * (canvasWidth - xOffset) / (stageCount) + xOffset;
            ctx.strokeStyle = "#c5f1ff";
            ctx.beginPath();
            ctx.moveTo(x, yOffset);
            ctx.lineTo(x, canvasHeight - yOffset);
            ctx.lineWidth = 1;
            ctx.stroke();
            ctx.closePath();
        }

        // горизонтальные оси
        for (var y = 0; y <= graphHeight; y += 20) {
            ctx.strokeStyle = "#c5f1ff";
            ctx.beginPath();
            ctx.moveTo(xOffset - 10, y + yOffset);
            ctx.lineTo(canvasWidth, y + yOffset);
            ctx.lineWidth = 1;
            ctx.stroke();
            ctx.closePath();
        }

        // подписи вертикальной оси
        for (var y = 0, i = 0; y <= graphWidth, i < yAxis.length; y = y + 40, i++) {
            ctx.fillStyle = "#5d6368";
            ctx.font = "12px/1 Gotham-Pro";
            ctx.textAlign = 'right';
            ctx.fillText(yAxis[i], 30, y + yOffset + 4); // + 4 смещение для выравнивания по вертикали
        }
    }

    function drawLine(ctx, xCoords, yCoords) {
        for (var i = 0, j = 0; i < xCoords.length, j < yCoords.length; i++ , j++) {
            var x = xCoords[i];
            var y = yCoords[j];
            if (resultCurrentStage === i + 1) {
                var gradientBg = ctx.createLinearGradient(x, 0, x, canvasHeight - yOffset);
                gradientBg.addColorStop(0, "rgba(255, 255, 255, 0.3)");
                gradientBg.addColorStop(0.7, "rgba(222, 247, 255, 0.4)");
                gradientBg.addColorStop(1, "rgba(255, 255, 255, 0.3)");
                ctx.fillStyle = gradientBg;
                ctx.fillRect(x - graphWidth / (stageCount * 2), yOffset, graphWidth / stageCount, canvasHeight - yOffset);

                var gradientLine = ctx.createLinearGradient(x, canvasHeight, x, y);
                gradientLine.addColorStop(0, "#ff8e32");
                gradientLine.addColorStop(1, "#6ebff7");
                ctx.fillStyle = gradientLine;
                ctx.fillRect(x - 3, y, 6, canvasHeight);
            }
            else {
                ctx.strokeStyle = "#6ebff7";
                ctx.fillStyle = "#6ebff7";
                ctx.beginPath();
                ctx.moveTo(x, canvasHeight - yOffset);
                ctx.lineTo(x, y);
                ctx.lineWidth = 1;
                ctx.stroke();
                ctx.closePath();
            }
        }
    }

    function drawGraph(ctx, xCoords, yCoords, color, siblingsGraphYCoords, graphType) {
        ctx.strokeStyle = color;
        ctx.beginPath();
        // если расстояния между соседними линиями графика <=4 (2 линиий толщиной 2)
        if (Math.abs(yCoords[0] - siblingsGraphYCoords[0]) <= 4) {
            if (graphType === 'stage') {
                ctx.moveTo(xCoords[0], yCoords[0] - 1);
            }
            else {
                ctx.moveTo(xCoords[0], yCoords[0] + 1);
            }
        }
        else {
            ctx.moveTo(xCoords[0], yCoords[0]);
        }

        for (var i = 1, j = 1, k = 1; i < xCoords.length, j < yCoords.length, k < siblingsGraphYCoords.length; i++ , j++ , k++) {
            var x = xCoords[i],
                y = yCoords[j],
                coordsDifferencePrev = Math.abs(siblingsGraphYCoords[j - 1] - siblingsGraphYCoords[k - 1]),
                coordsDifferenceNext = Math.abs(siblingsGraphYCoords[j] - siblingsGraphYCoords[k]);

            if (coordsDifferencePrev <= 4 && coordsDifferenceNext <= 4) {
                if (graphType === 'stage') {
                    ctx.lineTo(x, y - 1);
                }
                else {
                    ctx.lineTo(x, y + 1);
                }
            }
            else {
                ctx.lineTo(x, y);
            }
            ctx.lineWidth = 2;
            ctx.stroke();
        }
        ctx.closePath();
    }

    function drawDots(ctx, xCoords, yCoords, rating, siblingsGraphYCoords, color, graphType) {
        for (var i = 0, j = 0, k = 0; i < xCoords.length, j < yCoords.length, k < rating.length; i++ , j++ , k++) {
            var x = xCoords[i],
                y = yCoords[j],
                coordsDifference = Math.abs(siblingsGraphYCoords[j] - y);

            // размер 8угольника 45х30
            ctx.strokeStyle = color;
            ctx.fillStyle = "white";
            ctx.beginPath();

            if (coordsDifference > 30) {
                // рисуется против часовой стрелки
                ctx.moveTo(x - 13.5, y - 15);
                ctx.lineTo(x - 13.5 - 9, y - 15 + 9);
                ctx.lineTo(x - 13.5 - 9, y - 15 + 9 + 12);
                ctx.lineTo(x - 13.5 - 9 + 9, y - 15 + 9 + 12 + 9);
                ctx.lineTo(x - 13.5 - 9 + 9 + 27, y - 15 + 9 + 12 + 9);
                ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y - 15 + 9 + 12 + 9 - 9);
                ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y - 15 + 9 + 12 + 9 - 9 - 12);
                ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9, y - 15 + 9 + 12 + 9 - 9 - 12 - 9);
                ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9 - 27, y - 15 + 9 + 12 + 9 - 9 - 12 - 9);
            }
            else {
                if (y > siblingsGraphYCoords[j]) {
                    // рисуется против часовой стрелки
                    ctx.moveTo(x - 13.5, y - coordsDifference / 2 + 1.5);
                    ctx.lineTo(x - 13.5 - 9, y - coordsDifference / 2 + 1.5 + 9);
                    ctx.lineTo(x - 13.5 - 9, y - coordsDifference / 2 + 1.5 + 9 + 12);
                    ctx.lineTo(x - 13.5 - 9 + 9, y - coordsDifference / 2 + 1.5 + 9 + 12 + 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27, y - coordsDifference / 2 + 1.5 + 9 + 12 + 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y - coordsDifference / 2 + 1.5 + 9 + 12 + 9 - 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y - coordsDifference / 2 + 1.5 + 9 + 12 + 9 - 9 - 12);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9, y - coordsDifference / 2 + 1.5 + 9 + 12 + 9 - 9 - 12 - 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9 - 27, y - coordsDifference / 2 + 1.5 + 9 + 12 + 9 - 9 - 12 - 9);
                }
                else if (y < siblingsGraphYCoords[j]) {
                    // рисуется по часовой стрелке
                    ctx.moveTo(x - 13.5, y + coordsDifference / 2 - 1.5);
                    ctx.lineTo(x - 13.5 - 9, y + coordsDifference / 2 - 1.5 - 9);
                    ctx.lineTo(x - 13.5 - 9, y + coordsDifference / 2 - 1.5 - 9 - 12);
                    ctx.lineTo(x - 13.5 - 9 + 9, y + coordsDifference / 2 - 1.5 - 9 - 12 - 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27, y + coordsDifference / 2 - 1.5 - 9 - 12 - 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y + coordsDifference / 2 - 1.5 - 9 - 12 - 9 + 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y + coordsDifference / 2 - 1.5 - 9 - 12 - 9 + 9 + 12);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9, y + coordsDifference / 2 - 1.5 - 9 - 12 - 9 + 9 + 12 + 9);
                    ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9 - 27, y + coordsDifference / 2 - 1.5 - 9 - 12 - 9 + 9 + 12 + 9);
                }
                else if (y === siblingsGraphYCoords[j]) {
                    // рисуется по часовой стрелке
                    if (graphType === 'stage') {
                        ctx.moveTo(x - 13.5, y - 30);
                        ctx.lineTo(x - 13.5 - 9, y - 30 + 9);
                        ctx.lineTo(x - 13.5 - 9, y - 30 + 9 + 12);
                        ctx.lineTo(x - 13.5 - 9 + 9, y - 30 + 9 + 12 + 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27, y - 30 + 9 + 12 + 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y - 30 + 9 + 12 + 9 - 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y - 30 + 9 + 12 + 9 - 9 - 12);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9, y - 30 + 9 + 12 + 9 - 9 - 12 - 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9 - 27, y - 30 + 9 + 12 + 9 - 9 - 12 - 9);
                    }
                    else {
                        ctx.moveTo(x - 13.5, y + 2);
                        ctx.lineTo(x - 13.5 - 9, y + 2 + 9);
                        ctx.lineTo(x - 13.5 - 9, y + 2 + 9 + 12);
                        ctx.lineTo(x - 13.5 - 9 + 9, y + 2 + 9 + 12 + 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27, y + 2 + 9 + 12 + 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y + 2 + 9 + 12 + 9 - 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9, y + 2 + 9 + 12 + 9 - 9 - 12);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9, y + 2 + 9 + 12 + 9 - 9 - 12 - 9);
                        ctx.lineTo(x - 13.5 - 9 + 9 + 27 + 9 - 9 - 27, y + 2 + 9 + 12 + 9 - 9 - 12 - 9);
                    }
                }
            }
            ctx.lineWidth = 3;
            ctx.stroke();
            ctx.fill();

            // вставляю значение рейтинга в 8угольник
            ctx.fillStyle = color;
            ctx.font = "18px/1 Gotham-Bold";
            var text = ctx.measureText(rating[k]);
            ctx.textAlign = 'left';
            if (coordsDifference > 30) {
                ctx.fillText(rating[k], x - text.width / 2, +y + 6);
            }
            else {
                if (y > siblingsGraphYCoords[j]) {
                    ctx.fillText(rating[k], x - text.width / 2, +y - coordsDifference / 2 + 15 + 8);
                }
                else if (y < siblingsGraphYCoords[j]) {
                    ctx.fillText(rating[k], x - text.width / 2, +y + coordsDifference / 2 - 15 + 6);
                }
                else if (y === siblingsGraphYCoords[j]) {
                    if (graphType === 'stage') {
                        ctx.fillText(rating[k], x - text.width / 2, +y - 15 + 6);
                    }
                    else {
                        ctx.fillText(rating[k], x - text.width / 2, +y + 15 + 6);
                    }
                }
            }
        }
    }
}